export const MAX_WORKSPACE_NAME_LENGTH = 80
